export const prepareDate = (date: string) => date?.split('-').join('/')
